import { createFeatureSelector, createSelector, select } from '@ngrx/store'
import { AppMessages, AppState, CorpMemberState, FeedDataType, FeedViewType, PostHistoryState } from '../app.state'

export const corpMemberFeatureKey = 'corper'
export const feedFeatureKey = 'feed'
export const messagesFeatureKey = 'messages'
export const postHistoryFeatureKey = 'posted_items'

// explanation here https://stackoverflow.com/a/76989238/9259701

export const selectStateCorpMember = (state: AppState) => state.corper;

export const selectFeatureCorpMember =
    createFeatureSelector<CorpMemberState>(corpMemberFeatureKey)

export const selectFeatureFeed =
    createFeatureSelector<FeedDataType>(feedFeatureKey)

export const selectFeaturePostHistory =
    createFeatureSelector<PostHistoryState>(postHistoryFeatureKey)

export const selectFeatureCorpMemberPpaId = createSelector(
    selectFeatureCorpMember,
    (state: CorpMemberState) => state.ppa_id,
)

export const selectFeedView = (view: FeedViewType | null) => createSelector(
    selectFeatureFeed,
    // can make this a switch statement when we expand the view types
    (state: FeedDataType) => view === 'accommodation' ? state.accommodations : state.sales,
)

export const selectFeatureMessages =
    createFeatureSelector<AppMessages>(messagesFeatureKey)

